// Ingestion Sources Actions
const action = "INGESTION_SOURCES";

// List sources actions
export const LIST_REQUEST = action + '_LIST_REQUEST';
export const LIST_SUCCESS = action + '_LIST_SUCCESS';
export const LIST_FAILURE = action + '_LIST_FAILURE';

// Create source actions
export const CREATE_REQUEST = action + '_CREATE_REQUEST';
export const CREATE_SUCCESS = action + '_CREATE_SUCCESS';
export const CREATE_FAILURE = action + '_CREATE_FAILURE';

// Update source actions
export const UPDATE_REQUEST = action + '_UPDATE_REQUEST';
export const UPDATE_SUCCESS = action + '_UPDATE_SUCCESS';
export const UPDATE_FAILURE = action + '_UPDATE_FAILURE';

// Delete source actions
export const DELETE_REQUEST = action + '_DELETE_REQUEST';
export const DELETE_SUCCESS = action + '_DELETE_SUCCESS';
export const DELETE_FAILURE = action + '_DELETE_FAILURE';

// Test connection actions
export const TEST_REQUEST = action + '_TEST_REQUEST';
export const TEST_SUCCESS = action + '_TEST_SUCCESS';
export const TEST_FAILURE = action + '_TEST_FAILURE';

// Get schema actions
export const SCHEMA_REQUEST = action + '_SCHEMA_REQUEST';
export const SCHEMA_SUCCESS = action + '_SCHEMA_SUCCESS';
export const SCHEMA_FAILURE = action + '_SCHEMA_FAILURE';

// Get single source actions
export const GET_REQUEST = action + '_GET_REQUEST';
export const GET_SUCCESS = action + '_GET_SUCCESS';
export const GET_FAILURE = action + '_GET_FAILURE';

// Clear state action
export const CLEAR = action + '_CLEAR';

// Clear test result action
export const CLEAR_TEST_RESULT = action + '_CLEAR_TEST_RESULT';

// Action creators
export const listSources = (payload = {}) => ({
  type: LIST_REQUEST,
  payload
});

export const listSourcesSuccess = (response) => ({
  type: LIST_SUCCESS,
  payload: response
});

export const listSourcesFailure = (error) => ({
  type: LIST_FAILURE,
  payload: error
});

export const createSource = (payload) => ({
  type: CREATE_REQUEST,
  payload
});

export const createSourceSuccess = (response) => ({
  type: CREATE_SUCCESS,
  payload: response
});

export const createSourceFailure = (error) => ({
  type: CREATE_FAILURE,
  payload: error
});

export const updateSource = (sourceId, payload) => ({
  type: UPDATE_REQUEST,
  payload: { sourceId, ...payload }
});

export const updateSourceSuccess = (response) => ({
  type: UPDATE_SUCCESS,
  payload: response
});

export const updateSourceFailure = (error) => ({
  type: UPDATE_FAILURE,
  payload: error
});

export const deleteSource = (sourceId) => ({
  type: DELETE_REQUEST,
  payload: { sourceId }
});

export const deleteSourceSuccess = (response) => ({
  type: DELETE_SUCCESS,
  payload: response
});

export const deleteSourceFailure = (error) => ({
  type: DELETE_FAILURE,
  payload: error
});

export const testConnection = (sourceId, testData = null) => ({
  type: TEST_REQUEST,
  payload: { sourceId, testData }
});

export const testConnectionSuccess = (response) => ({
  type: TEST_SUCCESS,
  payload: response
});

export const testConnectionFailure = (error) => ({
  type: TEST_FAILURE,
  payload: error
});

export const getSchema = (sourceId) => ({
  type: SCHEMA_REQUEST,
  payload: { sourceId }
});

export const getSchemaSuccess = (response) => ({
  type: SCHEMA_SUCCESS,
  payload: response
});

export const getSchemaFailure = (error) => ({
  type: SCHEMA_FAILURE,
  payload: error
});

export const getSource = (sourceId) => ({
  type: GET_REQUEST,
  payload: { sourceId }
});

export const getSourceSuccess = (response) => ({
  type: GET_SUCCESS,
  payload: response
});

export const getSourceFailure = (error) => ({
  type: GET_FAILURE,
  payload: error
});

export const clearState = () => ({
  type: CLEAR
});

export const clearTestResult = (sourceId) => ({
  type: CLEAR_TEST_RESULT,
  payload: { sourceId }
});
